/**
 * Build identity for the running bundle.
 *
 * <p>The values come from `__QQT_BUILD_INFO__`, a compile-time constant substituted by the
 * `qqt-build-info` Vite plugin. Because it is a textual `define` and not a real global, any
 * consumer that runs outside a Vite build (bare `tsc`, some test runners) would throw on a
 * direct reference — hence the guarded read below.
 */
export interface BuildInfo {
  /** `yyyy.MM.dd.HH.mm.ss.<pipeline>` in UTC — the build id shown in the footer. */
  version: string;
  /** package.json semver, kept separate from the build id. */
  appVersion: string;
  /** GitLab `CI_PIPELINE_ID`, or "local". */
  buildNumber: string;
  /** Short commit SHA. */
  commit: string;
  /** Source branch. */
  branch: string;
  /** ISO-8601 UTC build instant. */
  builtAt: string;
}

const FALLBACK: BuildInfo = {
  version: "0000.00.00.00.00.00.dev",
  appVersion: "0.0.0",
  buildNumber: "dev",
  commit: "unknown",
  branch: "local",
  builtAt: new Date(0).toISOString(),
};

export const buildInfo: BuildInfo = (() => {
  try {
    return typeof __QQT_BUILD_INFO__ === "undefined" ? FALLBACK : __QQT_BUILD_INFO__;
  } catch {
    return FALLBACK;
  }
})();

/** The build id rendered in the footer and compared against `/version.json`. */
export const BUILD_VERSION = buildInfo.version;
